<template>
  <Layout
    header-class="header-left-align"
    :footer-style="4"
    buy-button-class="btn-default btn-small"
    :show-top-header="false"
    :show-copyright="false"
    :show-theme-switcher-button="false"
    :header-style="2"
    :other-bg="true"
  >
    <div class="slider-area">
      <div class="container">
        <div class="borrow-area">
          <div
            style="
              display: flex;
              align-items: center;
              padding: 0px 56px 0px 56px;
            "
          >
            <div
              :class="
                active === 1 ? 'depost-btn depost-btn-active' : 'depost-btn'
              "
              @click="active = 1"
            >
              Overview
            </div>
            <div
              :class="
                active === 2 ? 'depost-btn depost-btn-active' : 'depost-btn'
              "
              @click="active = 2"
            >
              My Assets
            </div>
            <div
              :class="
                active === 3 ? 'depost-btn depost-btn-active' : 'depost-btn'
              "
              @click="active = 3"
            >
              Rewards
            </div>
          </div>
          <div style="background: #1C2333;height: 61px;display: flex;align-items: center;justify-content: center;padding: 0px 56px;">
            <div style="height: 1px;background: rgba(255, 255, 255, 0.17);width: 100%;"></div>
          </div>
          <div style="padding-bottom: 50px;background: #1C2333;border-radius: 0px 0px 50px 50px;">
            <div
              style="
                padding-top: 46px;
                margin: 0px 56px 55px 56px;
                border-radius: 35px;
                border: 1px solid rgba(255, 255, 255, 0.5);
              "
              v-if="active === 1"
            >
              <div
                style="
                  border-bottom: 1px solid rgba(255, 255, 255, 0.17);
                  padding: 0px 74px 43px 74px;
                  margin: 0px 2px;
                "
                class="row"
              >
                <div class="col-4">
                  <div
                    style="
                      color: rgba(255, 255, 255, 0.37);
                      font-size: 20px;
                      font-weight: 500;
                      margin-bottom: 20px;
                    "
                  >
                    In Loan
                  </div>
                  <div style="color: white; font-size: 24px; font-weight: 900">
                    5 veVELO
                  </div>
                </div>
                <div class="col-4">
                  <div
                    style="
                      color: rgba(255, 255, 255, 0.37);
                      font-size: 20px;
                      font-weight: 500;
                      margin-bottom: 20px;
                    "
                  >
                    In Auction
                  </div>
                  <div style="color: white; font-size: 24px; font-weight: 900">
                    1 veVELO
                  </div>
                </div>
                <div class="col-4">
                  <div
                    style="
                      color: rgba(255, 255, 255, 0.37);
                      font-size: 20px;
                      font-weight: 500;
                      margin-bottom: 20px;
                    "
                  >
                    In Danger
                  </div>
                  <div style="color: white; font-size: 24px; font-weight: 900">
                    1 veVELO
                  </div>
                </div>
              </div>
              <div
                style="padding-bottom: 48px;border-bottom: 1px solid rgba(255, 255, 255, 0.17);padding: 0px 78px;"
              >
                <Counter
                  :counter-style="8"
                  text-align="left"
                  :counter-data="counterFiveData"
                  column="col-4"
                />
              </div>
              <div style="padding: 46px 78px 46px 70px" class="row">
                <div class="col-4">
                  <div style="font-size: 20px;font-weight: 500;color: #818DA9;margin-bottom: 13px;">
                    Total Rewards
                  </div>
                  <div style="font-weight: 900;font-size: 24px;color: white;">---</div>
                </div>
                <div class="col-4">
                  <div style="font-size: 20px;font-weight: 500;color: #818DA9;margin-bottom: 13px;">Claimed Rewards</div>
                  <div style="font-weight: 900;font-size: 24px;color: white;">---</div>
                </div>
                <div class="col-4">
                  <div style="font-size: 20px;font-weight: 500;color: #818DA9;margin-bottom: 13px;">Claimable Rewards</div>
                  <div style="font-weight: 900;font-size: 24px;color: white;">---</div>
                </div>
              </div>
            </div>
            <div v-else-if="active === 2" style="background: #1C2333;padding: 0px 51px;">
              <div class="search-area">
                <div style="display: flex; align-items: center">
                  <div style="padding-left: 20px">
                    <i class="el-icon-search" />
                  </div>
                  <div>
                    <el-input
                      style="
                        background: transparent;
                        border: none;
                        font-size: 15px;
                        outline: none;
                        height: 100%;
                        color: white;
                      "
                      class="search-input"
                      v-model.number="number"
                      placeholder="Search ID"
                      @input="onInput"
                    />
                  </div>
                </div>
                <div
                  style="
                    padding: 0px 40px 0px 25px;
                    height: 100%;
                    font-size: 15px;
                    color: rgba(255, 255, 255, 0.37);
                    border-left: 1px solid #c6c6c6;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                  "
                >
                <el-select v-model="value" placeholder="请选择" size="mini" :popper-append-to-body="false" style="width: 60px;" class="assets-token">
                  <el-option
                    label="veVELO"
                    value="veVELO">
                  </el-option>
                  <el-option
                    label="vePEARL"
                    value="vePEARL">
                  </el-option>
                </el-select>
                </div>
              </div>
              <div class="table-area">
                <table border="0" cellpadding="0" cellspacing="0">
                  <tr style="font-size: 13px; color: rgba(255, 255, 255, 0.67)">
                    <th>
                      <div class="left-td-div" style="height: 31px;border-color: #383C42;">ID</div>
                    </th>
                    <th>
                      <div class="middle-th-div" style="height: 31px;border-color: #383C42;">Value</div>
                    </th>
                    <th>
                      <div class="middle-th-div" style="height: 31px;border-color: #383C42;">Unlock time</div>
                    </th>
                    <th>
                      <div class="right-td-div" style="height: 31px;border-color: #383C42;">Action</div>
                    </th>
                  </tr>
                  <tr style="font-size: 15px; color: white" v-for="(item, index) in assetsData" :key="index">
                    <td>
                      <div class="left-td-div">{{ item.id }}</div>
                    </td>
                    <td>
                      <div class="middle-th-div">1234 {{ value }}</div>
                    </td>
                    <td>
                      <div class="middle-th-div">2024-01-01 00:00:00</div>
                    </td>
                    <td>
                      <div class="right-td-div">
                        <div class="btn-table">Borrow</div>
                        <div class="btn-table">Repay</div>
                        <div class="btn-table">Redeem</div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div v-else class="row" style="background: #1C2333;padding: 0px 51px;margin: 0px 2px;">
              <div class="col-4">
                <div class="time-item">
                  <div class="time-title">Current Epoch Start</div>
                  <div class="time-content">2023-01-07 00:00:00</div>
                </div>
              </div>
              <div class="col-4">
                <div class="time-item">
                  <div class="time-title">Lastest Claimed Epoch</div>
                  <div class="time-content">2023-01-07 00:00:00</div>
                </div>
              </div>
              <div
                style="
                  border-bottom: 1px solid rgba(255, 255, 255, 0.17);
                  margin-bottom: 27px;
                "
              >
                <Counter
                  :counter-style="8"
                  text-align="left"
                  :counter-data="counterFiveDataTwo"
                  column="col-4"
                />
              </div>
              <div class="table-area" style="height: auto">
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  style="margin-bottom: 0"
                >
                  <tr style="font-size: 13px; color: rgba(255, 255, 255, 0.67)">
                    <th>
                      <div class="left-td-div">Token</div>
                    </th>
                    <th>
                      <div class="middle-th-div">Symbol</div>
                    </th>
                    <th>
                      <div class="right-td-div">Balance</div>
                    </th>
                  </tr>
                  <tr style="font-size: 15px; color: white">
                    <td>
                      <div class="left-td-div">AUGU</div>
                    </td>
                    <td>
                      <div class="middle-th-div">AUGU</div>
                    </td>
                    <td>
                      <div class="right-td-div">1234.00</div>
                    </td>
                  </tr>
                  <tr style="font-size: 15px; color: white">
                    <td>
                      <div class="left-td-div">Velo</div>
                    </td>
                    <td>
                      <div class="middle-th-div">Velo</div>
                    </td>
                    <td>
                      <div class="right-td-div">1234.00</div>
                    </td>
                  </tr>
                  <tr style="font-size: 15px; color: white">
                    <td>
                      <div class="left-td-div">OP</div>
                    </td>
                    <td>
                      <div class="middle-th-div">OP</div>
                    </td>
                    <td>
                      <div class="right-td-div">1234.00</div>
                    </td>
                  </tr>
                </table>
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  margin-top: 27px;
                "
              >
                <div class="btn-rewards">Back</div>
                <div class="btn-claim">Claim</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Icon from '@/components/icon/Icon'
import Counter from '@/components/elements/counterUp/Counter'
import ServiceTwo from '@/components/elements/service/ServiceTwo'
import Web3 from 'web3'

export default {
  name: 'Borrow',
  components: {
    Icon,
    Layout,
    Counter,
    ServiceTwo,
  },
  data() {
    return {
      value: 'veVELO',
      number: '',
      iconOne: require('../assets/images/counter/icon-one.svg'),
      counterFiveData: [
        {
          number: 0,
          title: 'Current Debt',
          decimals: 2,
          prefix: 'Eth',
          icon: require('../assets/images/counter/icon-one.svg'),
        },
        {
          number: 0,
          title: 'Borrow APR',
          suffix: '%',
          decimals: 2,
          icon: require('../assets/images/counter/icon-three.svg'),
        },
        {
          number: 0,
          title: '',
          decimals: 2,
        },
      ],
      counterFiveDataTwo: [
        {
          number: 0,
          title: 'Total Deposit',
          decimals: 2,
          icon: require('../assets/images/counter/icon-two.svg'),
        },
        {
          number: 0,
          title: 'Total Borrowed',
          decimals: 2,
          icon: require('../assets/images/counter/icon-two.svg'),
        },
      ],
      cardXWidth: 0,
      containerHeight: '0px',
      progress: 0,
      innerWidth: 0,
      wrapperWidth: 0,
      maxProgress: 0,
      web3: null,
      account: '',
      active: this.$route.params && this.$route.params.id ? parseInt(this.$route.params.id) : 1,
      assetsOriginData: [
        {
          id: 101,
        },
        {
          id: 102,
        },
        {
          id: 103,
        },
        {
          id: 104,
        },
        {
          id: 105,
        },
        {
          id: 106,
        },
        {
          id: 107,
        },
        {
          id: 108,
        }
      ],
      assetsData: [
        {
          id: '101',
        },
        {
          id: '102',
        },
        {
          id: '103',
        },
        {
          id: '104',
        },
        {
          id: '105',
        },
        {
          id: '106',
        },
        {
          id: '107',
        },
        {
          id: '108',
        }
      ]
    }
  },
  watch: {
    "$route"(to, from) {
      if (to.params.id) {
        this.active = parseInt(to.params.id)
      }
    }
  },
  mounted() {
    // this.cardXWidth = this.$refs.cardX.getBoundingClientRect().width;
    // this.containerHeight = `${428 + 2004 - this.cardXWidth}px`
    // this.innerWidth = window.innerWidth
    // this.wrapperWidth = this.$refs.cardXContent.offsetWidth
    // this.maxProgress = (428 + 2004 - this.cardXWidth) / 2004 * 100
    // this.onScroll()
    // window.addEventListener('scroll', this.onScroll)
  },
  beforeUnmount() {
    // window.removeEventListener('scroll')
  },
  methods: {
    onInput(val) {
      this.number = val
      const result = []
      if (this.number || this.number === 0 || this.number === '0') {
        this.assetsOriginData.forEach(item => {
          if (item.id == this.number) {
            result.push(item)
          }
        })
        this.assetsData = result
      } else {
        this.assetsData = this.assetsOriginData
      }

    },
    async selectMetamask() {
      await this.initWeb3()
      await this.getAccount()
    },
    async initWeb3() {
      if (window.ethereum) {
        this.web3 = new Web3(window.ethereum)
        try {
          await window.ethereum.enable()
        } catch (error) {
          console.log(error)
        }
      } else if (window.web3) {
        this.web3 = new Web3(window.web3.currentProvider)
      }
    },
    async getAccount() {
      if (this.web3) {
        const accounts = await this.web3.eth.getAccounts()
        if (Array.isArray(accounts) && accounts.length > 0) {
          this.account = accounts[0]
          this.$account.metamask = accounts[0]
        }
      } else {
        this.$message.info('请安装Metamask！')
      }
    },
    onScroll() {
      const { scrollTop } = document.documentElement
      const containerTop = this.$refs.cardX.offsetTop + 428 - window.innerHeight
      const containerHeightNumber = 428 + 2004 - this.cardXWidth
      const newProgress =
        ((scrollTop - containerTop) * 100) /
        (containerHeightNumber - window.innerHeight + 428)
      this.progress = newProgress
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  min-height: calc(100vh - 80px);
  display: block;
  padding: 50px;
}
.borrow-area {
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.03);
  box-shadow: -2px 0px 20px 12px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(49px);
  padding-top: 19px;
  margin-bottom: 50px;
}

.depost-btn {
  width: 337.07px;
  height: 50px;
  background: #4E5973;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Outfit;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  border-radius: 20px;
  position: relative;
}

.depost-btn-active {
  color: #a1fe04;
  border-radius: 30px 30px 0px 0px;
  background: #1C2333;
}

.depost-btn-active::before,
.depost-btn-active::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
}

.depost-btn-active::before {
  left: -20px;
  /* 设置径向渐变 */
  background: radial-gradient(circle at 0 0,
      transparent 20px,
      #1C2333 20px);
}
.depost-btn-active::after {
  right: -20px;
  /* 设置径向渐变 */
  background: radial-gradient(circle at 20px 0,
      transparent 20px,
      #1C2333 20px); 
}

.action-btn {
  height: 64px;
  padding: 0px 36px;
  border-radius: 18px;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
  max-width: 243px;
  white-space: nowrap;
}

.search-area {
  height: 34px;
  width: 415px;
  border-radius: 20px;
  border: 1px solid #c6c6c6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.table-area {
  height: 500px;
  overflow: auto;
  table {
    tr {
      td {
        border: none;
        padding: 0px;
      }
    }
  }
}

.time-item {
  .time-title {
    color: rgba(255, 255, 255, 0.37);
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .time-content {
    color: #fff;
    font-size: 24px;
    font-weight: 900;
  }
}

.btn-rewards {
  width: 188px;
  height: 64px;
  border-radius: 18px;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  margin-right: 56px;
  cursor: pointer;
}

.btn-claim {
  width: 188px;
  height: 64px;
  border-radius: 18px;
  background: #a1fe04;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
}

.middle-th-div {
  border-top: 1px solid #c6c6c6;
  border-bottom: 1px solid #c6c6c6;
  height: 63px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding-right: 80px;
}

.left-td-div {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  border: 1px solid #c6c6c6;
  border-right: 0px;
  height: 63px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding-left: 48px;
  justify-content: center;
  padding-right: 130px;
}

.right-td-div {
  border-top-right-radius: 13px;
  border-bottom-right-radius: 13px;
  border: 1px solid #c6c6c6;
  border-left: 0px;
  padding-left: 47px;
  margin-bottom: 20px;
  height: 63px;
  display: flex;
  align-items: center;
}

.btn-table {
  width: 101.724px;
  // height: 34.712px;
  border-radius: 10px;
  cursor: pointer;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 15px;
  margin-right: 14px;
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.search-input{
  .el-input__inner {
    border: none !important;
  }
}
</style>
